module.exports = __webpack_public_path__ + "img/fail.8fb433a3.svg";